// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"636":"landing","846":"writer"}[chunkId] + "." + {"636":"1429799d","846":"cc7a95af"}[chunkId] + ".css";
};